import { render } from "./App.vue?vue&type=template&id=44351fb1"
const script = {}
script.render = render

export default script